module.exports = __webpack_public_path__ + "static/img/pipeline_111.c3ed3626.png";